import Vue from 'vue';
import Inputmask from 'inputmask';
import { logger } from '@/helpers/log.service';

/*
https://github.com/RobinHerbots/Inputmask#inputmask
https://github.com/RobinHerbots/Inputmask/blob/5.x/README_date.md#datetime-extensions
https://github.com/RobinHerbots/Inputmask/blob/5.x/README_numeric.md#numeric-extensions
https://github.com/RobinHerbots/Inputmask/blob/5.x/README_other.md#other-extensions
*/
Vue.directive('mask', {
  bind: function(el, model) {
    if (model.value) {
      let mask;
      let id;
      let component;
      if (typeof model.value === 'string') {
        mask = model.value;
      } else {
        mask = model.value.mask;
        id = model.value.id;
        component = model.value.component;
      }
      if (mask) {
        let target;
        if (id) {
          let elements = el.getElementsByTagName('input');
          for (let i in elements) {
            if (elements[i].id === id) {
              target = elements[i];
              break;
            }
          }
        } else {
          target = el.getElementsByTagName('input')[0];
        }

        if (target) {
          // noinspection JSUnusedGlobalSymbols
          let opts = {
            showMaskOnHover: false,
            onBeforeMask: function(value) {
              if (mask === 'phone' && value && value.length === 10 && typeof value === 'string' && value.startsWith('0')) {
                return value.substring(1);
              }
              return value;
            },
            onBeforeWrite: function(e) {
              // m.diachuk: this ugly crutch is supposed to fix not working(in case of using Inputmask) browser autocomplete
              try {
                let inputEl = id && component.$refs[id] && component.$refs[id].$refs['input']
                  ? component.$refs[id].$refs['input']
                  : null;
                if (component && inputEl && e && e.type === 'checkval') {
                  component.$emit('input', component.$refs[id].$refs['input'].value);
                }
              } catch (err) {
                logger.warn('Error occurred while trying to save value got from browser autocomplete', err);
              }
            }
          };
          if (mask === 'date') {
            new Inputmask('datetime', Object.assign(opts, { inputFormat: 'dd/mm/yyyy', placeholder: 'DD/MM/YYYY' })).mask(target);
          } else if (mask === 'time') {
            new Inputmask(Object.assign({ regex: String.raw`^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$`, placeholder: 'hh:mm:ss' }, opts)).mask(target);
          } else if (mask === 'phone') {
            new Inputmask(Object.assign(opts, { mask: '(99) 999 99 99', autoUnmask: true, placeholder: '*' })).mask(target);
          } else if (mask === 'email') {
            new Inputmask('email', opts).mask(target);
          } else if (mask === 'integer') {
            let allowMinus = model.value && 'allowMinus' in model.value ? model.value['allowMinus'] : true;
            new Inputmask('integer', Object.assign(opts, { rightAlign: false, allowMinus })).mask(target);
          } else if (mask === 'decimal') {
            new Inputmask('decimal', Object.assign(opts, { rightAlign: false })).mask(target);
          } else if (typeof model.value === 'object') {
            new Inputmask(Object.assign(opts, model.value)).mask(target);
          }
        }
      }
    }
  }
});
